import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>ANGKA138 ~ Platform Penyedia Game Online Dengan Kualitas Terbaik Tahun Ini</title>
        <meta property="og:title" content="ANGKA138 ~ Platform Penyedia Game Online Dengan Kualitas Terbaik Tahun Ini" />
        <meta name="google-site-verification" content="prkzvR_LVVuiacJqOGm7ONnFtMLoOyUUJxclk8HdML8" />
        <link
          rel="canonical"
          href="https://amp-angka-138.pages.dev/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-video-container">
          <video
            src="https://videos.pexels.com/video-files/7670836/7670836-hd_1280_720_30fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/7670836/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content home-thq-hero-content-elm">
          <div className="hero-brand-container">
            <img
              alt="image"
              src="/hd_restoration_result_image-1100h.png"
              className="home-image1"
            />
            <p className="hero-subtitle">
              SITUS YANG SUDAH DIPERCAYA SELAMA LEBIH DARI 5 TAHUN
            </p>
          </div>
          <img
            alt="image"
            src="/klub%20final%20(2)-500h.jpg"
            className="home-image2"
          />
          <div className="hero-actions">
            <a
              href="https://t.ly/Ads-angka"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="btn-xl btn-gold-solid btn btn-secondary">
                <span>DAFTAR</span>
              </div>
            </a>
            <a
              href="https://t.ly/Ads-angka"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="btn-outline btn-xl btn btn-gold-outline">
                <span>LOGIN</span>
              </div>
            </a>
          </div>
          <div>
            <div className="home-container12">
              <Script
                html={`<style>
@keyframes strokePulse {
0%, 100% {
  box-shadow: 0 0 0 0 rgba(176, 127, 32, 0.7);
}
50% {
  box-shadow: 0 0 0 10px rgba(176, 127, 32, 0);
}
}
</style>`}
              ></Script>
            </div>
          </div>
          <div>
            <div className="home-container14">
              <Script
                html={`<style>
@keyframes shimmerStroke {
0% {
  border-color: var(--color-secondary);
  box-shadow: 0 0 10px rgba(176, 127, 32, 0.3), inset 0 0 10px rgba(176, 127, 32, 0.1);
}
25% {
  border-color: var(--color-secondary);
  box-shadow: 0 0 20px rgba(176, 127, 32, 0.6), inset 5px 0 15px rgba(176, 127, 32, 0.2);
}
50% {
  border-color: var(--color-secondary);
  box-shadow: 0 0 25px rgba(176, 127, 32, 0.8), inset 0 5px 15px rgba(176, 127, 32, 0.3);
}
75% {
  border-color: var(--color-secondary);
  box-shadow: 0 0 20px rgba(176, 127, 32, 0.6), inset -5px 0 15px rgba(176, 127, 32, 0.2);
}
100% {
  border-color: var(--color-secondary);
  box-shadow: 0 0 10px rgba(176, 127, 32, 0.3), inset 0 0 10px rgba(176, 127, 32, 0.1);
}
}
</style>`}
              ></Script>
            </div>
          </div>
          <div>
            <div className="home-container16">
              <Script
                html={`<style>
@keyframes shimmerStroke {
0% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 20px 0 30px rgba(176, 127, 20, 0.8),
                0 0 30px rgba(176, 127, 20, 0.6);
}
12.5% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 14px 14px 30px rgba(176, 127, 20, 0.8),
                0 0 35px rgba(176, 127, 20, 0.7);
}
25% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 0 20px 30px rgba(176, 127, 20, 0.8),
                0 0 40px rgba(176, 127, 20, 0.8);
}
37.5% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset -14px 14px 30px rgba(176, 127, 20, 0.8),
                0 0 35px rgba(176, 127, 20, 0.7);
}
50% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset -20px 0 30px rgba(176, 127, 20, 0.8),
                0 0 30px rgba(176, 127, 20, 0.6);
}
62.5% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset -14px -14px 30px rgba(176, 127, 20, 0.8),
                0 0 35px rgba(176, 127, 20, 0.7);
}
75% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 0 -20px 30px rgba(176, 127, 20, 0.8),
                0 0 40px rgba(176, 127, 20, 0.8);
}
87.5% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 14px -14px 30px rgba(176, 127, 20, 0.8),
                0 0 35px rgba(176, 127, 20, 0.7);
}
100% {
  box-shadow: inset 0 0 0 3px var(--color-secondary), 
                inset 20px 0 30px rgba(176, 127, 20, 0.8),
                0 0 30px rgba(176, 127, 20, 0.6);
}
}
</style>`}
              ></Script>
            </div>
          </div>
        </div>
      </section>
      <section className="features-section">
        <div className="features-container">
          <div className="feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294zM5 21h14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="feature-text">
              <h2 className="feature-title section-title">
                Dukungan Prioritas
              </h2>
              <p className="section-content">
                Customer Service Tersedia 24 Jam
              </p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="feature-text">
              <h2 className="feature-title section-title">
                Penawaran Terbatas
              </h2>
              <p className="section-content">Main Dan Dapatkan Bonus Besar</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <div className="feature-text">
              <h2 className="feature-title section-title">Dipastikan Aman</h2>
              <p className="section-content">
                Sudah Memiliki Lisensi Judi Online Sejak 2020
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p className="testimonial-quote section-subtitle">
              Akhirnya maxwin juga di ANGKA138!! Dari deposit 100rb jadi jutaan
              dalam semalam. CS ramah, proses cepat. Rekomendasi buat yang lagi
              cari situs gacor.
            </p>
            <span className="testimonial-author">
              Marko ananda.,member platinum
            </span>
          </div>
          <div className="testimonial-card">
            <p className="testimonial-quote section-subtitle">
              Akhirnya maxwin juga di ANGKA138!! Dari deposit 100rb jadi jutaan
              dalam semalam. CS ramah, proses cepat. Rekomendasi buat yang lagi
              cari situs gacor.
            </p>
            <span className="testimonial-author">
              fiky  navi niatsirk.,member
            </span>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card">
            <div className="cta-header">
              <h2 className="section-title">
                <span>AYO DAFTAR</span>
                <br></br>
                <span>SEKARANG!</span>
                <br></br>
              </h2>
              <p className="section-content">CUMA BUTUH 60 DETIK!!!</p>
            </div>
            <div className="cta-form-wrapper">
              <a href="https://t.ly/Ads-angka">
                <div className="btn-gold-solid btn-lg btn btn-secondary">
                  <span>JOIN ANGKA138 SEKARANG</span>
                </div>
              </a>
              <a href="https://t.ly/Ads-angka">
                <p className="home-thq-cta-footer-text-elm cta-footer-text">
                  <span>Sudah Jadi Member?</span>
                  <div className="home-thq-cta-link-elm">
                    <span>Login Disini</span>
                  </div>
                </p>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container17">
        <div className="home-container18">
          <Script
            html={`<script defer data-name="hero-scroll-effects">
(function(){
  const heroContent = document.querySelector(".hero-content")
  const heroVideo = document.querySelector(".hero-video")

  window.addEventListener("scroll", () => {
    const scrollValue = window.scrollY

    if (heroContent) {
      const delayStart = 500; // Orang harus scroll 300px dulu baru mulai memudar
const fadeRange = 400;  // Durasi pemudaran setelah delay selesai
const opacity = 1 - Math.max(0, scrollValue - delayStart) / fadeRange;
      const translate = scrollValue * 0.3
      heroContent.style.opacity = Math.max(opacity, 0)
      heroContent.style.transform = \`translateY(\${translate}px)\`
    }

    if (heroVideo) {
      heroVideo.style.transform = \`scale(\${1 + scrollValue * 0.0005})\`
    }
  })

  const featureItems = document.querySelectorAll(".feature-item")
  const observerOptions = {
    threshold: 0.2,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }, index * 150)
        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  featureItems.forEach((item) => {
    item.style.opacity = "0"
    item.style.transform = "translateY(30px)"
    item.style.transition = "all 0.6s ease-out"
    observer.observe(item)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      <a href="https://play.teleporthq.io/signup">
        <div aria-label="Sign up to TeleportHQ" className="home-container19">
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="home-icon18"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="home-text19">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Home
